// Shared "have we painted a page yet this session?" flag.
//
// Both PageTransition and ScrollReveal want to skip their entrance animation on
// the very first page of a session (so a load doesn't flash content in) but
// animate on subsequent client-side navigations. They must express that by
// changing animation PROPS, never by returning a different element type — see
// the comment in PageTransition for what that cost us.
let painted = false;

export const hasPaintedOnce = () => painted;
export const markPainted = () => {
  painted = true;
};
